// [ICON_IMPORTS_START]
import React from 'react';
import playSVG from "./svgs/play.svg"
import registrationSVG from "./svgs/registration.svg"
import advancedSVG from "./svgs/advanced.svg"
import competitionSVG from "./svgs/competition.svg"
import finalEventSVG from "./svgs/finalEvent.svg"
import finalistsSVG from "./svgs/finalists.svg"
import trainingSVG from "./svgs/training.svg"
import arrowsSVG from "./svgs/arrows.svg";
import keySVG from "./svgs/key.svg"
import victoryCupSVG from "./svgs/victoryCup.svg"
import finalVictoryCupSVG from "./svgs/finalVictoryCup.svg"
import exportSVG from "./svgs/export.svg"
import closeSVG from "./svgs/close.svg"
import starSVG from "./svgs/star.svg"
import qualifyingBSVG from "./svgs/qualifyingB.svg"
import checkSVG from "./svgs/check.svg"
import peopleSVG from "./svgs/people.svg"
import silverMedalSVG from "./svgs/silverMedal.svg"
import medalSVG from "./svgs/medal.svg"
import desktopSVG from "./svgs/desktop.svg"
import virtualSchoolSVG from "./svgs/virtualSchool.svg"
import goldMedalSVG from "./svgs/goldMedal.svg"
import countersStarSVG from "./svgs/countersStar.svg"
import rightSVG from "./svgs/right.svg"
import leftSVG from "./svgs/left.svg"
import checkmarkGreenSVG from "./svgs/checkmarkGreen.svg"
import downSVG from "./svgs/down.svg"
import downloadSVG from "./svgs/download.svg"
import calendarSVG from "./svgs/calendar.svg"
import clockSVG from "./svgs/clock.svg"
import cameraSVG from "./svgs/camera.svg"
import finalParticipantsSVG from "./svgs/finalParticipants.svg"
import finalStagesSVG from "./svgs/finalStages.svg"
import finalMinutesSVG from "./svgs/finalMinutes.svg"
import finalBoysGirlsSVG from "./svgs/finalBoysGirls.svg"
import zoomSVG from "./svgs/zoom.svg"
import eventsSVG from "./svgs/events.svg"
import everyoneSVG from "./svgs/everyone.svg"
import backArrowSVG from "./svgs/backArrow.svg"
import threeDotsSVG from "./svgs/threeDots.svg"
import classes from './Icon.module.css';

const iconComponents = {
    play: playSVG,
    registration: registrationSVG,
    advanced: advancedSVG,
    competition: competitionSVG,
    finalEvent: finalEventSVG,
    finalists: finalistsSVG,
    training: trainingSVG,
    arrows: arrowsSVG,
    key: keySVG,
    victoryCup: victoryCupSVG,
    finalVictoryCup: finalVictoryCupSVG,
    export: exportSVG,
    close: closeSVG,
    star: starSVG,
    qualifyingB: qualifyingBSVG,
    check: checkSVG,
    people: peopleSVG,
    silverMedal: silverMedalSVG,
    medal: medalSVG,
    desktop: desktopSVG,
    virtualSchool: virtualSchoolSVG,
    goldMedal: goldMedalSVG,
    countersStar: countersStarSVG,
    right: rightSVG,
    left: leftSVG,
    checkmarkGreen: checkmarkGreenSVG,
    down: downSVG,
    download: downloadSVG,
    calendar: calendarSVG,
    clock: clockSVG,
    camera: cameraSVG,
    finalParticipants: finalParticipantsSVG,
    finalStages: finalStagesSVG,
    finalMinutes: finalMinutesSVG,
    finalBoysGirls: finalBoysGirlsSVG,
    zoom: zoomSVG,
    events: eventsSVG,
    everyone: everyoneSVG,
    backArrow: backArrowSVG,
    threeDots: threeDotsSVG,
};

const Icon = ({ color, name, size, onClick, className, tooltip }) => {

    const IconComponent = iconComponents[name];

    if (!IconComponent) {
        return null;
    }

    return (
        <div
            className={`${classes.Icon} ${className || ''}`}
            onClick={onClick && onClick}
            dangerouslySetInnerHTML={{ __html: IconComponent }}
            style={{ color: color && color, stroke: color && color, width: size, height: size }}
        />
    );
}
export default Icon;


